/* set the height of the menu rows after final re-render */
export const setMenuRowsHeight = heights => dispatch => dispatch({ type: 'SET_MENU_ROWS_HEIGHT', heights })
